import { combineReducers } from 'redux';
import user from './user';
import metering from './metering';
import navigation from './navigation';

export default combineReducers({
  user,
  meter: metering,
  navigation,
});
